import Select from "react-select";
import { useFormContext } from "contexts/FormContext";
import { Modal } from "react-bootstrap";

const CustomerModal = () => {
  // contexts
  const { formState, setFormState } = useFormContext();

  return (
    <Modal
      show={formState.customerModal}
      onHide={() => setFormState({ key: "customerModal", value: false })}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        {/* <p>Please choose your customer:</p> */}
      </Modal.Header>
      <Modal.Body>
        <p>Please choose your customer:</p>
        <Select
          required
          value={formState.info.customer}
          onChange={(e) => {
            setFormState({ key: "info.customer", value: e });
            setFormState({ key: "customerModal", value: false });
          }}
          options={formState.customers?.map((x) => ({
            value: x,
            label: x.name,
          }))}
        />
      </Modal.Body>
    </Modal>
  );
};

export default CustomerModal;
